/**
 * TenantsProvider
 * Contain most logic handing with Omnitech Api
 */

import React, { useContext, useState, useEffect, useCallback } from 'react'
import _ from 'lodash'

import { CacheChecksumContext, createPersistedState } from '../../cache'
import TenantsContext from './tenants-context'
import { fetchTenant } from './tenants-api'
import { cancelRequest } from '../../helpers'
import config from '../../config'

// create use state hook with persisted storage
// TODO: support using different storage provider
const useTenantState = createPersistedState('tenant')
const useTenantsChecksumState = createPersistedState('tenantsChecksum')

export default function TenantsProvider({ children }) {
  // handle system setting cache checksum value
  const { getChecksum } = useContext(CacheChecksumContext)
  const cacheChecksumValue = getChecksum('tenants')

  // manage state for system setting and checksum
  const [tenant, setTenant] = useTenantState({})
  const [tenantsChecksum, setTenantsChecksum] = useTenantsChecksumState('')
  const [tenantReady, setTenantReady] = useState(false)
  const [enableRefresh, setEnableRefresh] = useState(false)

  const tenantCode = config.get('api.tenantCode')

  /**
   * get system setting from omnitech API when app is mounted
   */
  useEffect(() => {
    // skip when tenantCode is empty
    if (_.isEmpty(tenantCode)) {
      setTenantReady(true)
      return
    }

    const promise = fetchTenant({ code: tenantCode })
    promise
      .then(({ cacheChecksum, tenant }) => {
        setTenant(tenant)
        setTenantReady(true)
        setEnableRefresh(true)
        setTenantsChecksum(cacheChecksum)
      })
      .catch(error => {
        // TODO: handle error
      })
    return function cleanUp() {
      cancelRequest.cancelAll(['fetchTenants'])
    }
  }, [tenantCode])

  // update tenant cache base on cache checksum
  useEffect(() => {
    if (!tenantReady || _.isUndefined(cacheChecksumValue)) return

    // when it is not required to update cache, skip the process
    if (!enableRefresh || tenantsChecksum === cacheChecksumValue) {
      if (_.isEmpty(tenantsChecksum) && !_.isEmpty(cacheChecksumValue)) {
        setTenantsChecksum(cacheChecksumValue)
      }
      return
    }

    // start refreshing tenant with omnitech API
    setEnableRefresh(false)
    const promise = fetchTenant({ code: tenantCode })
    promise
      .then(({ cacheChecksum, tenant }) => {
        setTenant(tenant)
        setTenantsChecksum(cacheChecksum)
      })
      .catch(error => {
        // TODO: handle error
        console.warn('error: ', error)
      })
      .finally(() => {
        setEnableRefresh(true)
      })
    return function cleanUp() {
      cancelRequest.cancelAll(['fetchTenant'])
    }
  }, [tenantsChecksum, tenantReady, cacheChecksumValue])

  const state = {
    tenant,
    tenantReady,
  }
  return (
    <TenantsContext.Provider value={state}>
      {children}
    </TenantsContext.Provider>
  )
}
